import { useEffect } from 'react'
import { sendTelemetryDocument } from '../api/data-connectors/telemetry'
import { getDocumentUrl } from '../api/word/office-service'
import { TELEMETRY_ENABLED } from '../constants/telemetry'

/**
 * Reports the open Word document's path to telemetry once when the task pane loads.
 *
 * If the user renames the document later in the same session, we do not try to catch that.
 * They will send the new path the next time they open the document in a fresh add-in session.
 */
export function useWorkingDocumentTelemetry() {
  useEffect(() => {
    if (!TELEMETRY_ENABLED) return

    getDocumentUrl().then((documentUrl) => {
      if (documentUrl) sendTelemetryDocument('word', documentUrl)
    })
  }, [])
}
